<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <img
      src="https://storage.googleapis.com/komerce/assets/logo/logo-komerce-no-tag.svg"
      alt="logo"
      width="176px"
      class="mb-[40px]"
    >
    <h1 class="text-2xl font-semibold text-center text-red-500">
      Integrasi Marketplace Gagal
    </h1>
    <p class="text-sm text-gray-500 text-center mb-[24px] max-w-[500px]">
      Maaf, integrasi tidak dapat dilanjutkan. Hal ini dapat terjadi karena kendala sistem atau akun marketplace ini telah digunakan oleh pengguna lain. Silakan coba kembali, gunakan akun yang belum terhubung, atau hubungi kami kalau butuh bantuan.
    </p>
    <p class="text-sm text-gray-500 text-center mb-[24px] max-w-[500px]">
      *Anda dapat menutup halaman ini untuk kembali ke halaman sebelumnya.
    </p>
    <a
      href="https://wa.me/6281325862737"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button class="btn btn-primary px-[16px] py-[8px] bg-primary text-white hover:bg-primary-dark transition">
        Hubungi Customer Support
      </button>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ErrorIntegrationPage',
  mounted() {
    this.notifyParent()
  },
  methods: {
    /**
     * Notify the parent window that the integration is failed
     */
    notifyParent() {
      try {
        const bc = new BroadcastChannel('marketplace_integration')
        bc.postMessage({
          type: 'INTEGRATION_FAILED',
          data: {
            integration_success: false,
          },
        })
        bc.close()
      } catch (e) {
        console.error('BroadcastChannel error:', e)
      }
    },
  },
}
</script>
